'use client';

import { useState, useEffect, useCallback } from 'react';
import { useSwipeable } from 'react-swipeable';
import SliderItem from '@/components/wigets/slider-item';
import SliderThumbnailItem from '@/components/wigets/slider-thumbnail-item';
import Arrows from '@/components/wigets/arrows';

const sliderData = [
  {
    id: 1,
    image: '/images/hero1.png',
    brand: '',
    name: 'CIGE Perú',
    desc: '',
  },
  {
    id: 2,
    image: '/images/hero2.png',
    brand: '',
    name: 'Reportes SAP B1',
    desc: '',
  },
  {
    id: 3,
    image: '/images/hero3.png',
    brand: '',
    name: 'CIGE FI Contadores',
    desc: '',
  },
  {
    id: 4,
    image: '/images/hero4.png',
    brand: '',
    name: 'Facturación Electrónica web',
    desc: '',
  },
  {
    id: 5,
    image: '/images/hero5.png',
    brand: '',
    name: 'Guía Electrónica web',
    desc: '',
  } 
];

export default function Hero3() {
  const [itemActive, setItemActive] = useState<number>(1);
  const [isAutoPlaying, setIsAutoPlaying] = useState<boolean>(true);
  const totalItems = sliderData.length;

  // Función para obtener el orden circular de las miniaturas
  const getCircularThumbnailOrder = (activeId: number): number[] => {
    const order: number[] = [];
    let current = activeId % totalItems + 1;
    
    for (let i = 0; i < totalItems; i++) {
      if (current > totalItems) current = 1;
      order.push(current);
      current++;
    }
    
    return order;
  };

 const handleNext = useCallback(() => {
  setItemActive(current => current % totalItems + 1);
}, [totalItems]);
  const handlePrevious = () => {
    setItemActive(current => (current === 1 ? totalItems : current - 1));
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isAutoPlaying) {
      interval = setInterval(handleNext, 10000);
    }

    return () => clearInterval(interval);
  }, [isAutoPlaying, handleNext]);

  function handleInteraction() {
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 30000);
  }

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      handleInteraction();
      handleNext();
    },
    onSwipedRight: () => {
      handleInteraction();
      handlePrevious();
    },
    trackMouse: true,
  });

  const thumbnailOrder = getCircularThumbnailOrder(itemActive);

  return (
    <div className="h-screen relative" {...handlers}>
      {/* Slider principal */}
      <ul>
        {sliderData.map((item) => (
          <SliderItem
            key={item.id}
            itemActive={itemActive}
            {...item}
          />
        ))}
      </ul>

      {/* Flechas de navegación */}
      <Arrows 
        onClickPrev={() => {
          handleInteraction();
          handlePrevious();
        }} 
        onClickNext={() => {
          handleInteraction();
          handleNext();
        }} 
      />

      {/* Miniaturas */}
      <ul className="absolute top-0 right-0 z-10 flex justify-end gap-3 w-full h-[250px] px-14 overflow-hidden">
        {thumbnailOrder.map((id, index) => {
          const item = sliderData.find(slide => slide.id === id)!;
          return (
            <SliderThumbnailItem
              key={`${item.id}-${index}`}
              itemActive={itemActive}
              image={item.image}
              id={item.id}
              name={item.name}
              onClick={() => {
                handleInteraction();
                setItemActive(item.id);
              }}
              isFirst={index === 0}
            />
          );
        })}
      </ul>
    </div>
  );
}